
export default {
  props: ['articles','pages','page','title'],
  
  
};
